module.exports = __webpack_public_path__ + "static/media/thumb.fb34e887.jpg";